import PropTypes from 'prop-types';
import { StoryblokCache, initializeRedis } from '@cache/redis';
import { OllieStoryblokClient } from '@web/cms/api';
import {
  PUP_INFO_SUBPATH,
  VALID_WEIGHT_SUBPATHS,
} from '../../../health/HealthScreeningContainer/constants';
import { PrefixedReporterProvider } from '../../../reporter';
import { MetaAttributes } from '../../../head';
import { HealthScreeningContainer } from '../../../health';
import { withFlagshipSession } from '../../../auth/withFlagshipSession';
import { withGladlySetting } from '../../../gladly';
import { healthScreeningSchema } from '../../../health/builders';
import { server } from '../../../config';

const WeightPage = ({ content }) => {
  const cmsContent = healthScreeningSchema.validateSync(content);

  return (
    <PrefixedReporterProvider prefix={content.taggingPrefix}>
      <MetaAttributes seoTitle={content.seoTitle} />
      <HealthScreeningContainer content={cmsContent} />
    </PrefixedReporterProvider>
  );
};

/**
 * @type {import('next').GetServerSideProps}
 */
export const getServerSideProps = withGladlySetting(
  withFlagshipSession(async ({ params }) => {
    const [subpath = PUP_INFO_SUBPATH, ...rest] = params.path ?? [];

    // only valid if there is two additional path params
    if (rest.length)
      return {
        props: {},
      };
    let content = {};

    // 404 if the subpath exists & isn't in the list.
    if (!VALID_WEIGHT_SUBPATHS.includes(subpath)) {
      return {
        notFound: true,
      };
    }

    // Narrows down to the pages that exist in the CMS
    const redis = initializeRedis({
      host: server.REDIS_HOST,
      port: server.REDIS_PORT,
    });

    const storyblokRedis = new StoryblokCache(redis);
    const ollieStoryblokClient = new OllieStoryblokClient(storyblokRedis);
    const storySlug = `/health/weight/${subpath}`;
    content = (await ollieStoryblokClient.getStory(storySlug)).data.story
      .content;

    return {
      props: {
        content,
      },
    };
  }),
);

WeightPage.displayName = 'WeightPage';

WeightPage.propTypes = {
  content: PropTypes.object,
};

export default WeightPage;
